module.exports = __webpack_public_path__ + "static/media/executive-digital-fire-safe.4a7e1ebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/executive-digital-fire-safe.png
// module id = 1284
// module chunks = 0